export default "__VITE_ASSET__GEVnh4PO__"